module.exports = __webpack_public_path__ + "img/vespa_85.1de35581.png";